/**
 * @fileoverview Utility function for calculating age from a birth date.
 */

/**
 * Calculates a person's age based on their birth date.
 *
 * The function accounts for whether the person's birthday has occurred
 * in the current year, providing an accurate age calculation.
 *
 * @param {string|Date} value - The birth date as a string or Date object
 * @returns {number} The calculated age in years
 *
 * @example
 * calculateAge('1990-05-15'); // Returns current age (e.g., 34 in 2024)
 * calculateAge(new Date(1990, 4, 15)); // Same as above
 */
export function calculateAge(value) {
    const birthDate = new Date(value);
    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();

    const currentMonth = today.getMonth();
    const currentDay = today.getDate();
    const birthMonth = birthDate.getMonth();
    const birthDay = birthDate.getDate();

    // Adjust if the birthday hasn't occurred yet this year
    if (currentMonth < birthMonth || (currentMonth === birthMonth && currentDay < birthDay)) {
      age--;
    }

    return age;
  }